import { ChartTypeName } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import AudienceProfile from '@components/shared/CampaignAnalytics/ChartDefinitions/AudienceProfile';
import BrandLocationVisits from '@components/shared/CampaignAnalytics/ChartDefinitions/BrandLocationVisits';
import { EditableChartProps } from './chartProps';
import DmaVisits from '@components/shared/CampaignAnalytics/ChartDefinitions/DmaVisits';
import FootTrafficOverlap from '@components/shared/CampaignAnalytics/ChartDefinitions/FootTrafficOverlap';
import ProximityToHome from '@components/shared/CampaignAnalytics/ChartDefinitions/ProximityToHome';
import StateVisits from '@components/shared/CampaignAnalytics/ChartDefinitions/StateVisits';
import TimeToFirstVisit from '@components/shared/CampaignAnalytics/ChartDefinitions/TimeToFirstVisit';
import VisitsByDayOfWeek from '@components/shared/CampaignAnalytics/ChartDefinitions/VisitsByDayOfWeek';
import { ComponentType } from 'react';
import { DemographicProfile } from '@components/shared/CampaignAnalytics/ChartDefinitions/DemographicProfile';
import VisitsByHourOfDay from './VisitsByHourOfDay';

export type ChartDefinition = {
  title: string;
  id: ChartTypeName;
  ChartComponent: ComponentType<EditableChartProps>;
};

export const charts: ChartDefinition[] = [
  {
    title: 'Audience Profile',
    id: 'audienceProfile',
    ChartComponent: AudienceProfile,
  },
  {
    title: 'Demographic Profile',
    id: 'demographicProfile',
    ChartComponent: DemographicProfile,
  },
  {
    title: 'Top State Visits',
    id: 'stateVisits',
    ChartComponent: StateVisits,
  },
  {
    title: 'Top DMA Visits',
    id: 'dmaVisits',
    ChartComponent: DmaVisits,
  },
  {
    title: 'Top *dynamic text* Brand Location Visits',
    id: 'brandLocationVisits',
    ChartComponent: BrandLocationVisits,
  },
  {
    title: 'Proximity to Home',
    id: 'proximityToHome',
    ChartComponent: ProximityToHome,
  },
  {
    title: 'Time to First Visit',
    id: 'timeToFirstVisitByDay',
    ChartComponent: TimeToFirstVisit,
  },
  {
    title: 'Visits by Time of Day',
    id: 'visitsByHourOfDay',
    ChartComponent: VisitsByHourOfDay,
  },
  {
    title: 'Visits by Day of Week',
    id: 'visitsByDayOfWeek',
    ChartComponent: VisitsByDayOfWeek,
  },
  {
    title: 'Foot Traffic Overlap',
    id: 'footTrafficOverlap',
    ChartComponent: FootTrafficOverlap,
  },
];
